"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _banner = require("./banner");
Object.keys(_banner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _banner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _banner[key];
    }
  });
});
var _carousel = require("./carousel");
Object.keys(_carousel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _carousel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _carousel[key];
    }
  });
});
var _dealLabel = require("./dealLabel");
Object.keys(_dealLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dealLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dealLabel[key];
    }
  });
});
var _lazyImage = require("./lazyImage");
Object.keys(_lazyImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _lazyImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _lazyImage[key];
    }
  });
});
var _loading = require("./loading");
Object.keys(_loading).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _loading[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _loading[key];
    }
  });
});
var _lowestPreviousPrice = require("./lowestPreviousPrice");
Object.keys(_lowestPreviousPrice).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _lowestPreviousPrice[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _lowestPreviousPrice[key];
    }
  });
});
var _ppaLabel = require("./ppaLabel");
Object.keys(_ppaLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ppaLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ppaLabel[key];
    }
  });
});
var _productTile = require("./productTile");
Object.keys(_productTile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productTile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _productTile[key];
    }
  });
});
var _quickBuyButton = require("./quickBuyButton");
Object.keys(_quickBuyButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _quickBuyButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _quickBuyButton[key];
    }
  });
});
//# sourceMappingURL=index.js.map